import { ComponentType, LazyExoticComponent } from 'react';
import { RouteObject } from 'react-router';

import { ServiceCode, IntegrationSystem } from '@/shared/types';

import { SERVICE_CODES } from '@/lib/consts';

import { RouteConfig, RoutesBySystem } from '../types';

import { ServiceWrapper } from './ServiceWrapper';

export function createSystemRoutes<T extends IntegrationSystem>(
  system: T,
  routeConfigs: Record<keyof RoutesBySystem<T>, RouteConfig>,
  systemComponents: Record<keyof RoutesBySystem<T>, LazyExoticComponent<ComponentType<any>>>,
): RouteObject {
  const systemServiceKeys = Object.keys(routeConfigs) as Array<keyof RoutesBySystem<T>>;

  return {
    path: system,
    children: systemServiceKeys.reduce<RouteObject[]>((acc, serviceCodeKeyName) => {
      const config = routeConfigs[serviceCodeKeyName];
      const component = systemComponents[serviceCodeKeyName];
      const serviceCode = SERVICE_CODES[serviceCodeKeyName as keyof typeof SERVICE_CODES] as ServiceCode;

      if (!component) {
        return acc;
      }

      const serviceRoute: RouteObject = {
        path: config.basePath,
        children: [
          {
            path: config.path,
            element: (
              <ServiceWrapper isPrivate={config.isPrivate} serviceCode={serviceCode}>
                {component}
              </ServiceWrapper>
            ),
          },
        ],
      };

      acc.push(serviceRoute);
      return acc;
    }, []),
  };
}
